module.exports = __webpack_public_path__ + "static/media/--WhiteBluePNG-TM.5c49fecc.png";